import { css } from '@emotion/css';

export const main = css`
`;
